import { carouselItems } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-800 text-xs font-medium mb-4 whitespace-nowrap">
            <i className="ri-focus-2-line"></i>
            深度阅读
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            焦点专题
          </h2>
          <p className="text-sm text-foreground-500 mt-2">深度解读近期最受关注的娱乐事件</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {carouselItems.map((item, idx) => (
            <div
              key={idx}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-colors cursor-pointer flex flex-col"
            >
              <div className="relative aspect-[2/1] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 text-[10px] font-bold rounded-full bg-primary-500 text-background-50 whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-5 flex flex-col flex-1">
                <h3 className="text-sm font-heading font-bold text-foreground-900 mb-2 line-clamp-2">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-3 flex-1">{item.desc}</p>
                <div className="flex items-center gap-1 mt-3 text-xs text-primary-500 opacity-0 group-hover:opacity-100 transition-opacity">
                  <span>阅读全文</span>
                  <i className="ri-arrow-right-line text-[10px]"></i>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}